// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicantDataWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordApplicantDataWebApiHandler_getApplicantDetails,
  CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Path,
  CappsLandlordApplicantDataWebApiHandler_getApplicantSummary,
  CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Path,
  CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails,
  CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Path,
} from '@zg-rentals/ts-capps-client';

import type {
  ApplicantDetailsResponseDto,
  ApplicantSummaryResponseDto,
  GuarantorDetailsResponseDto,
  ListingAlias,
  Zuid,
} from '@zg-rentals/ts-capps-client';

interface GetApplicantDetailsParams {
  applicantUserId: Zuid;
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetApplicantSummaryParams {
  applicantUserId: Zuid;
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetGuarantorDetailsParams {
  applicationId: string;
  invitingApplicantUserId: Zuid;
  listingAlias: ListingAlias;
}

export type CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Options = UseQueryOptions<
  ApplicantDetailsResponseDto,
  unknown,
  ApplicantDetailsResponseDto,
  readonly [string, GetApplicantDetailsParams]
>;

const CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_GetKey = (getParams: GetApplicantDetailsParams) =>
  [CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Path, getParams] as const;

export const CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_queryOptions = (
  getParams: GetApplicantDetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_GetKey(getParams),
    queryFn: () => CappsLandlordApplicantDataWebApiHandler_getApplicantDetails(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicantDataWebApiHandler_getApplicantDetails = (
  getParams: GetApplicantDetailsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicantDataWebApiHandler_getApplicantDetails.getKey =
  CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_GetKey;

export type CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Options = UseQueryOptions<
  ApplicantSummaryResponseDto,
  unknown,
  ApplicantSummaryResponseDto,
  readonly [string, GetApplicantSummaryParams]
>;

const CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_GetKey = (getParams: GetApplicantSummaryParams) =>
  [CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Path, getParams] as const;

export const CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_queryOptions = (
  getParams: GetApplicantSummaryParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_GetKey(getParams),
    queryFn: () => CappsLandlordApplicantDataWebApiHandler_getApplicantSummary(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicantDataWebApiHandler_getApplicantSummary = (
  getParams: GetApplicantSummaryParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicantDataWebApiHandler_getApplicantSummary.getKey =
  CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_GetKey;

export type CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Options = UseQueryOptions<
  GuarantorDetailsResponseDto,
  unknown,
  GuarantorDetailsResponseDto,
  readonly [string, GetGuarantorDetailsParams]
>;

const CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_GetKey = (getParams: GetGuarantorDetailsParams) =>
  [CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Path, getParams] as const;

export const CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_queryOptions = (
  getParams: GetGuarantorDetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_GetKey(getParams),
    queryFn: () => CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicantDataWebApiHandler_getGuarantorDetails = (
  getParams: GetGuarantorDetailsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicantDataWebApiHandler_getGuarantorDetails.getKey =
  CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_GetKey;
